// extracted by mini-css-extract-plugin
module.exports = {"card-overlay-wrapper":"product-diagram-drawer_card-overlay-wrapper__8gcaR","sticky-check-price-container":"product-diagram-drawer_sticky-check-price-container__Q5yWy"};